/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from "react";
// import {
//   VKShareButton,
//   VKIcon,
//   EmailShareButton,
//   EmailIcon,
//   WhatsappShareButton,
//   WhatsappIcon,
//   TelegramShareButton,
//   TelegramIcon,
// } from 'next-share';
import { getDateString } from "../../services/support";
import dynamic from 'next/dynamic';
const Breadcrumbs = dynamic(() => import("../../components/breadcrumbs"));
import sanityClient from "../../../public/support-func/sanityClient";
import Head from "next/head";

import { PortableText } from "@portabletext/react";
import Image from "next/image";
import { urlFor } from "../../../public/support-func/sanity-support";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
import Vimeo from "@u-wave/react-vimeo";
import getVideoId from "get-video-id";
import { groq } from "next-sanity";

export async function getStaticProps({ params }) {
	const postQuery = groq`*[_type == "stories" && active == true && isPremier == true][0]`;
	const pageData = await sanityClient.fetch(postQuery);

	return {
		props: {
			pageData: pageData,
		},
		revalidate: 60,
	};
}

const components = {
	block: {
		normal: ({ children }) => <p className="text">{children}</p>,
	},
	types: {
		one_image: ({ value }) => {
			const { asset, alt, caption } = value;
			return (
				<div className="story_img">
					<Image
						className="img"
						src={urlFor(asset._ref).url()}
						alt={alt}
						width={200}
						height={200}
					/>
				</div>
			);
		},
		one_image_vertical: ({ value }) => {
			const { asset, alt, caption } = value;
			return (
				<div className="story_img  story_img--vertical">
					<Image
						className="img"
						src={urlFor(asset._ref).url()}
						alt={alt}
						width={200}
						height={200}
					/>
				</div>
			);
		},
		youtubeVideo: ({ node }) => {
			const { url } = node;
			const { id } = getVideoId(url);
			return (
				<div className="youtube_video_container">
					<LiteYouTubeEmbed title={id} id={id} />
				</div>
			);
		},
		vimeoVideo: ({ value }) => {
			const { url } = value;
			const { id } = getVideoId(url);
			return <Vimeo className="post__video" video={id}></Vimeo>;
		},
	},
};

const useFormattedDate = (date) => {
	const [formattedDate, setFormattedDate] = useState(null);

	useEffect(() => setFormattedDate(getDateString(date)), []);

	return formattedDate;
};

const Premier = ({ pageData }) => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<>
			<Head>
				<title>{pageData?.title}</title>
				<meta name="keywords" content={pageData?.tags} />
				<meta
					name="description"
					content={pageData?.shortDescription}
					key="ogdesc"
				/>

				<meta
					property="og:site_name"
					content="Alina-Avelis"
					key="ogsitename"
				/>
				<meta property="og:type" content="story" key="ogtype" />
				<meta
					property="og:url"
					content={`http://localhost:3000/premier`}
					key="ogurl"
				/>
				<meta
					property="og:description"
					content={pageData?.shortDescription}
				/>
				<meta property="og:title" content={pageData?.title} />
			</Head>
			<Breadcrumbs pathArr={[{ name: "Премьера" }]} />
			{pageData ? (
				<>
					<h1>{pageData?.title}</h1>

					{/* <div className="socials_share">
            <VKShareButton
              url={'https://github.com/next-share'}
              image={'./next-share.png'}
            >
              <VKIcon size={24} round />
            </VKShareButton>

            <EmailShareButton
              url={'https://github.com/next-share'}
              subject={'Next Share'}
              body="body"
            >
              <EmailIcon size={24} round />
            </EmailShareButton>

            <TelegramShareButton
              url={'https://github.com/next-share'}
              title={'next-share is a social share buttons for your next React apps.'}
            >
              <TelegramIcon size={24} round />
            </TelegramShareButton>

            <WhatsappShareButton
              url={'https://github.com/next-share'}
              title={'next-share is a social share buttons for your next React apps.'}
              separator=":: "
            >
              <WhatsappIcon size={24} round />
            </WhatsappShareButton>
          </div> */}

					<PortableText
						value={pageData?.content}
						components={components}
					/>
					<p className="story_date">
						{useFormattedDate(pageData?.releaseDate)}
					</p>
				</>
			) : (
				<p className="text big_card_text big_text">
					Здесь еще ничего нет
				</p>
			)}
		</>
	);
};

export default Premier;
